<!--Компонент для отображения левое меню-->
<template>
  <v-navigation-drawer
    location="left"
    v-if="leftMenu.enabled"
    v-model="leftMenu.show"
    id="main-left-menu"
    width="300"
  >
    <CurrentLeftMenu
      :items="leftMenu.items"
      class="overflow-hidden"/>

    <template v-slot:append>
      <InstanceLeftMenu
        :instances="leftMenu.instances"
        :current_instance="leftMenu.currentInstance"/>
    </template>
  </v-navigation-drawer>
</template>

<script>
import CurrentLeftMenu from "@/modules/core/components/menus/left_menu/CurrentLeftMenu.vue"
import InstanceLeftMenu from "@/modules/core/components/menus/left_menu/InstanceLeftMenu.vue"
import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * Компонент левого меню приложения
 * Отображает основное меню навигации и меню выбора инстансов
 */
export default {
  name: 'LeftMenu',

  components: {
    CurrentLeftMenu,
    InstanceLeftMenu
  },

  /**
   * Настраивает реактивные свойства компонента
   * @returns {Object} объект с реактивными свойствами
   */
  setup () {
    const store = useStore()

    /**
     * Получает состояние левого меню из хранилища Vuex
     * @type {ComputedRef<Object>}
     */
    const leftMenu = computed(() => store.state.leftmenu)

    return {
      leftMenu,
    }
  }
}

</script>

<style scoped>

</style>
